import { createAction } from 'deox';
import {
  GET_CARTS_REQUEST,
  GET_CARTS_SUCCESS,
  CartDTO,
  GET_CARTS_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
  CREATE_CART_REQUEST,
  CREATE_CART_SUCCESS,
  CREATE_CART_FAILURE,
  DELETE_CART_REQUEST,
  DELETE_CART_SUCCESS,
  DELETE_CART_FAILURE,
  COMMIT_CART_REQUEST,
  COMMIT_CART_SUCCESS,
  COMMIT_CART_FAILURE,
  ADD_ITEMS_REQUEST,
  CartItemDTO,
  ADD_ITEMS_SUCCESS,
  ADD_ITEMS_FAILURE,
  GET_CART_ITEM_REQUEST,
  GET_CART_ITEM_SUCCESS,
  GET_CART_ITEM_FAILURE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_FAILURE,
  DELETE_CART_ITEM_REQUEST,
  DELETE_CART_ITEM_SUCCESS,
  DELETE_CART_ITEM_FAILURE,
  SEARCH_SUPPLIERS_SUCCESS,
  SEARCH_SUPPLIERS_FAILURE,
  SEARCH_SUPPLIERS_REQUEST,
  SupplierDTO,
  GET_SUPPLIERS_FAILURE,
  GET_SUPPLIERS_REQUEST,
  GET_SUPPLIERS_SUCCESS,
  SearchResultsProps,
} from './types';

// Получение списка корзин
export const getCartsAction = {
  request: createAction(GET_CARTS_REQUEST),
  success: createAction(GET_CARTS_SUCCESS, resolve => (data: CartDTO) => resolve(data)),
  failure: createAction(GET_CARTS_FAILURE, resolve => (error: string) => resolve(error)),
};

// Получение одной корзины по ID
export const getCartByIdAction = {
  request: createAction(GET_CART_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(GET_CART_SUCCESS, resolve => (data: CartDTO) => resolve(data)),
  failure: createAction(GET_CART_FAILURE, resolve => (error: string) => resolve(error)),
};

// Создание новой корзины
export const createCartAction = {
  request: createAction(
    CREATE_CART_REQUEST,
    resolve => (data: CartDTO['order_items']) => resolve(data),
  ),
  success: createAction(CREATE_CART_SUCCESS, resolve => (data: CartDTO) => resolve(data)),
  failure: createAction(CREATE_CART_FAILURE, resolve => (error: string) => resolve(error)),
};

// Удаление корзины по ID
export const deleteCartAction = {
  request: createAction(DELETE_CART_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(DELETE_CART_SUCCESS, resolve => (id: string) => resolve(id)),
  failure: createAction(DELETE_CART_FAILURE, resolve => (error: string) => resolve(error)),
};

// Коммит корзины
export const commitCartAction = {
  request: createAction(COMMIT_CART_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(COMMIT_CART_SUCCESS, resolve => (data: CartDTO) => resolve(data)),
  failure: createAction(COMMIT_CART_FAILURE, resolve => (error: string) => resolve(error)),
};

// Добавление товаров в корзину
export const addItemsAction = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: createAction(ADD_ITEMS_REQUEST, resolve => (items: any) => resolve({ items })),
  success: createAction(ADD_ITEMS_SUCCESS, resolve => (data: CartDTO) => resolve(data)),
  failure: createAction(ADD_ITEMS_FAILURE, resolve => (error: string) => resolve(error)),
};

// Получение товара из корзины по ID
export const getCartItemAction = {
  request: createAction(GET_CART_ITEM_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(GET_CART_ITEM_SUCCESS, resolve => (data: CartItemDTO) => resolve(data)),
  failure: createAction(GET_CART_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};

// Обновление товара в корзине по ID
export const updateCartItemAction = {
  request: createAction(
    UPDATE_CART_ITEM_REQUEST,
    resolve => (id: string, item: Partial<CartItemDTO>) => resolve({ id, item }),
  ),
  success: createAction(UPDATE_CART_ITEM_SUCCESS, resolve => (data: CartItemDTO) => resolve(data)),
  failure: createAction(UPDATE_CART_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};

// Удаление товара из корзины по ID
export const deleteCartItemAction = {
  request: createAction(DELETE_CART_ITEM_REQUEST, resolve => (id: string[]) => resolve(id)),
  success: createAction(DELETE_CART_ITEM_SUCCESS),
  failure: createAction(DELETE_CART_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};

export const getSuppliersAction = {
  request: createAction(GET_SUPPLIERS_REQUEST),
  success: createAction(GET_SUPPLIERS_SUCCESS, resolve => (data: SupplierDTO[]) => resolve(data)),
  failure: createAction(GET_SUPPLIERS_FAILURE, resolve => (error: string) => resolve(error)),
};

// Action for searching suppliers
export const searchSuppliersAction = {
  request: createAction(
    SEARCH_SUPPLIERS_REQUEST,
    resolve =>
      (params: {
        price_gt?: number;
        price_lt?: number;
        delivery_term_gt?: number;
        delivery_term_lt?: number;
        brand?: string;
        supplier?: string;
        amount_gt?: number;
        name?: string;
        brand_article?: string;
        search_text?: string;
      }) =>
        resolve(params),
  ),
  success: createAction(
    SEARCH_SUPPLIERS_SUCCESS,
    resolve => (data: SearchResultsProps) => resolve(data),
  ),
  failure: createAction(SEARCH_SUPPLIERS_FAILURE, resolve => (error: string) => resolve(error)),
};
